import { Component } from "@angular/core";

@Component({
    template: "<h2>Page not found</h2>",
})
export class PageNotFoundComponent { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular-router-loader/src!./ClientApp/app/errors/not-found.component.ts